import React from 'react';
import { makeStyles } from '~/lib/bn-material-ui';
import { getFillThreshold } from '~/bins/bin-level/bin-level-fill';

const useStyles = makeStyles((theme) => {
  const greenLight = theme.palette.fillLevel.high;
  const greenDark = theme.palette.fillLevel.highDark;
  const orangeLight = theme.palette.fillLevel.medium;
  const orangeDark = theme.palette.fillLevel.mediumDark;
  const redLight = theme.palette.fillLevel.low;
  const redDark = theme.palette.fillLevel.lowDark;

  return {
    fill: {
      width: 'inherit',
      position: 'absolute',
      bottom: '0',
      opacity: 0.9,
      transition: 'height .2s ease-out',
    },
    high: {
      background: `repeating-linear-gradient(-22.5deg, ${greenLight}, ${greenLight} 20px, ${greenDark} 20px, ${greenDark} 40px)`,
    },
    medium: {
      background: `repeating-linear-gradient(-22.5deg, ${orangeLight}, ${orangeLight} 20px, ${orangeDark} 20px, ${orangeDark} 40px)`,
    },
    low: {
      background: `repeating-linear-gradient(-22.5deg, ${redLight}, ${redLight} 20px, ${redDark} 20px, ${redDark} 40px)`,
    },
    dark: {
      background: theme.palette.blue[60],
      zIndex: 2,
    },
    light: {
      background: theme.palette.blue[50],
      zIndex: 1,
    },
  };
});

export function BinLevelFillStripes({ volume, totalVolume }) {
  const styles = useStyles();
  const fillRatio = volume / totalVolume || 0;
  const fillThreshold = getFillThreshold(fillRatio);

  return (
    <div
      style={{ height: `${fillRatio * 100}%` }}
      className={`${styles[fillThreshold]} ${styles.fill}`}
    />
  );
}

export function BinLevelFillSolids({ totalVolume, volumes }) {
  const styles = useStyles();
  const solidFill = (index) => {
    if (index === 0) {
      return styles.dark;
    }
    if (index === 1) {
      return styles.light;
    }
  };

  const cumulativeVolumes = volumes.reduce((prev,curr,index) => (prev.push(index ? curr + prev[index - 1] : curr), prev), []);

  return cumulativeVolumes.map((level, index) => (
    <div
      key={`${level}-${index}`}
      style={{ height: `${(level / totalVolume) * 100}%` }}
      className={`${solidFill(index)} ${styles.fill}`}
    />
  ));
}
